import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import image1 from '../assets/1.webp';
import image2 from '../assets/2.webp';
import image3 from '../assets/3.webp';
import image4 from '../assets/4.webp';

const Services: React.FC = () => {
  const { t } = useTranslation();

  const services = t('services.list', { returnObjects: true });
  const descriptions = t('services.descriptions', { returnObjects: true });
  const servicesList = Array.isArray(services) ? services : [];
  const descriptionsList = Array.isArray(descriptions) ? descriptions : [];
  const images = [image1, image2, image3, image4];

  return (
    <section className="py-20 bg-white" id="services">
      <div className="container mx-auto px-4" >
        <motion.h2
          className="text-4xl font-bold text-center mb-16 text-gradient"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {t('services.title')}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {servicesList.map((service, index) => (
            <motion.div
              key={index}
              className="bg-glass rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <img 
                src={images[index]} 
                alt={service} 
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{service}</h3>
                <p className="text-gray-600">{descriptionsList[index]}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;